import { ModalName, ModalsMapType } from 'redux/Modals/types';

import DoublePurchasedAlert from 'modals/DoublePurchasedAlert';

export const MODAL_LIST: ModalsMapType = {
    [ModalName.doublePurchasedAlert]: DoublePurchasedAlert,
};
